module.exports = __webpack_public_path__ + "static/buyer-login-8e437b9c82c6328ead22ee95f496813b.gif";